import React from "react";
import { useField, useFormikContext, ErrorMessage, Form } from "formik";
import DatePicker from "react-datepicker";


const onlyShowFridays = function (date) {
    const day = date.getDay();
    return day === 5;
}

export const DatePickerField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);

    const onlyShowFridays = (date) => {
        const day = date.getDay();
        return day === 5;
    }
    const filterDates = (props.onlyShowFridays ? onlyShowFridays : (x) => { return true })
    return (
        <div className="form-group">
            <label for={props.name} style={{marginBottom:"0.5rem"}}>
                {props.label}
            </label>
            <DatePicker
                id={props.name}
                {...field}
                {...props}
                selected={(field.value && new Date(field.value)) || null}
                onChange={val => {
                    setFieldValue(field.name, val);
                    if (props.onChange) {
                        props.onChange(val)
                    }
                }}
                filterDate={filterDates}
                className="form-control w-100"
            />
            <ErrorMessage name={field.name} component="div" />
        </div>
    );
};

export default DatePickerField;